import { useQuery } from "../../Utils/utils"

export const usePageQuery = (search) => {
  const query = useQuery(search)
  return {
    openInvoiceID: query.get("open_invoice"),
    user_id: query.get("user_id")
  }
}
